// Import components
import CreateButton from "global/components/CreateButton";



// Function to render all filters with checkboxes (list of filterable values with checkbox)
const CreateCheckboxFilters = ({

    uniqueFilterOptions,

    selectedFilters,

    filterLabels,

    clearFilterGroup,

    toggleFilterValue,

    // So we can clear any selected table rows when changing filters
    setSelectedRows

}) => (

    Object.entries(uniqueFilterOptions).map(([key, values]) => {

        // Get selected values for this filter group or default to empty array
        const selectedValues = selectedFilters[key] || [];

        return (

            <div key={key} className="filters__filter-group">

                <div className="horizontal-align-content-center">

                    {/* Filter List Title */}
                    <p className="filters__label">{filterLabels[key]}</p>

                    {/* Clear All Selected Button */}
                    {selectedValues.length > 0 ? (

                        <CreateButton title="x" type="button" size="xs" onClick={() => clearFilterGroup(key)} className="filters__clear-button" />
                    )
                        :

                        (
                            // Add empty space if no 'clear' button
                            <span style={{ width: "20px" }}></span>
                        )

                    }

                </div>

                {/* Individual Checkboxes */}
                {values.map((val) => (

                    <label key={val} className="filters__checkbox-label">
                        <input
                            type="checkbox"
                            checked={selectedFilters[key]?.includes(val) || false}
                            onChange={() => {
                                setSelectedRows([]);
                                toggleFilterValue(key, val);
                            }}
                            className="filters__checkbox"
                        />
                        {val}
                    </label>

                ))}

            </div>

        );

    })

);

export default CreateCheckboxFilters;